import React from "react";

interface ButtonProps {
  buttonText: string;
  className?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset" | undefined;
}

const Button: React.FC<ButtonProps> = ({
  buttonText,
  className = "",
  onClick,
  type = "button",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`w-full bg-black px-3 py-2 rounded font-medium ${className}`}
    >
      {buttonText}
    </button>
  );
};

export default Button;
